//@ts-nocheck
import {
  Avatar,
  Badge,
  Box,
  BoxProps,
  Button,
  ButtonGroup,
  Center,
  Circle,
  Flex,
  FlexProps,
  HStack,
  Icon,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Select,
  SimpleGrid,
  SquareProps,
  Stack,
  Text,
  useColorModeValue as mode,
  useColorModeValue,
  useDisclosure,
  VisuallyHidden,
} from "@chakra-ui/react";
import * as React from "react";
import { AiOutlineUser } from "react-icons/ai";
import { MdMenu } from "react-icons/md";
import {
  RiCustomerServiceLine,
  RiHeartLine,
  RiMenuLine,
  RiSearchLine,
  RiShoppingCartLine,
} from "react-icons/ri";
import { CheckBadgeIcon } from "../../../icons";
import { TuteriaLogo as Logo } from "../../assets";
import {
  ContactModalType,
  ContactUs,
  DropdownItemType,
  HoverNavDropdown,
  MenuItemType,
  NavCategorySubmenu,
  PopoverIcon,
  SearchResultType,
  SearchHistoryType,
  SearchLikeButton,
} from "./components";

export const SearchInput = () => {
  return (
    <InputGroup>
      <InputLeftElement>
        <Icon as={RiSearchLine} color="gray.500" fontSize="lg" />
      </InputLeftElement>
      <Input
        focusBorderColor="blue.500"
        width="full"
        fontSize="sm"
        variant="filled"
        type="text"
        placeholder="What are you looking for?"
        autoComplete="off"
      />
    </InputGroup>
  );
};

export const items = {
  wishlist: {
    label: "Wishlist",
    icon: RiHeartLine,
    href: "#",
  },
  user: {
    label: "Sign in",
    icon: AiOutlineUser,
    href: "#",
  },
  cart: {
    label: "Cart",
    icon: RiShoppingCartLine,
    href: "#",
  },
  search: {
    label: "Search",
    icon: RiSearchLine,
    href: "#",
  },
};

type NavFeaturedImageProps = BoxProps & {
  label: string;
  href?: string;
  imageUrl: string;
  bottomOffset?: string;
};

export const NavFeaturedImage = (props: NavFeaturedImageProps) => {
  const { label, href = "#", imageUrl, bottomOffset = "5", ...rest } = props;
  return (
    <Box
      as="a"
      display="block"
      href={href}
      height="280px"
      width="full"
      position="relative"
      userSelect="none"
      {...rest}
    >
      <Image
        w="full"
        fit="cover"
        rounded="lg"
        alt={label}
        src={imageUrl}
        height="full"
        position="relative"
      />
      <Box
        whiteSpace="nowrap"
        textTransform="uppercase"
        fontWeight="semibold"
        fontSize="sm"
        px="3"
        py="0.5"
        rounded="sm"
        bg={mode("white", "gray.600")}
        position="absolute"
        bottom={bottomOffset}
        left="50%"
        transform="auto"
        translateX="-50%"
      >
        {label}
      </Box>
    </Box>
  );
};

const MobileNavCategorySubmenu = () => (
  <Box p="5" width="full" height="100%" overflowY="auto">
    <Text fontWeight="bold" mb="4">
      Men
    </Text>
    <NavFeaturedImage
      height="32"
      bottomOffset="3"
      label="Men's Suit"
      imageUrl="https://images.unsplash.com/photo-1623880840102-7df0a9f3545b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=928&q=80"
    />
    <Stack spacing="10" mt="10">
      <Box>
        <Text fontWeight="bold" mb="4">
          {data.category.label}
        </Text>
        <SimpleGrid columns={2} spacing="4">
          {data.category.links.map((link) => (
            <Link key={link.label} href={link.url}>
              {link.label}
            </Link>
          ))}
        </SimpleGrid>
      </Box>
      <Box>
        <Text fontWeight="bold" mb="4">
          {data.featured.label}
        </Text>
        <SimpleGrid columns={2} spacing="4">
          {data.featured.links.map((link) => (
            <Link key={link.label} href={link.url}>
              {link.label}
            </Link>
          ))}
        </SimpleGrid>
      </Box>
    </Stack>
  </Box>
);

// export const NavCategorySubmenu = {
//   Mobile: MobileNavCategorySubmenu,
//   Desktop: DesktopNavCategorySubmenu,
// };

type NavItemProps = {
  isActive?: boolean;
  href?: string;
  label?: string;
  tag?: string;
};

const DesktopNavItem = (props: FlexProps & NavItemProps) => {
  const { label, href, tag, ...rest } = props;
  return (
    <Center minH="4.5rem">
      <HStack
        as="a"
        position="relative"
        href={href}
        cursor="pointer"
        color="gray.600"
        _hover={{
          color: "blue.500",
          opacity: 1,
          textDecor: "none",
        }}
      >
        <CheckBadgeIcon />
        <Flex
          direction="column"
          justify="center"
          fontSize="sm"
          fontWeight={400}
          position="relative"
          whiteSpace="nowrap"
          flexWrap="nowrap"
          {...rest}
        >
          {label}
        </Flex>
      </HStack>
    </Center>
  );
};

const MobileNavItem = (props: BoxProps & NavItemProps) => {
  const { label, href, isActive, ...rest } = props;
  return (
    <Box
      as="a"
      href={href}
      aria-current={isActive ? "page" : undefined}
      py="2"
      px="3"
      _activeLink={{
        bg: mode("white", "gray.600"),
        shadow: "base",
      }}
      {...rest}
    >
      {label}
    </Box>
  );
};

const NavItem = {
  Desktop: DesktopNavItem,
  Mobile: MobileNavItem,
};

const menus = [
  { label: "Home Tutoring", href: "#" },
  { label: "IELTS Prep", href: "#" },
  { label: "HCA Program", href: "#" },
  { label: "Common Entrance", href: "#" },
  { label: "IGCSE Classes", href: "#" },
  { label: "GRE Prep", href: "#" },
  { label: "Homework Help", href: "#" },
  { label: "Literary Club", href: "#" },
  { label: "Languages", href: "#" },
  { label: "Music", href: "#" },
];

const DesktopNavCategoryMenu = () => {
  return (
    <Box py={1} bg="white" maxW="1560px" mx="auto" px={{ base: "8", lg: "16" }}>
      <Box
        sx={{
          maxW: "1560px",
          mx: "auto",
          overflowX: "scroll",
          scrollbarWidth: "none",
          "-ms-overflow-style": "none",
          "-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <HStack spacing="8" width="full" justify="space-between">
          {menus.map((link) => (
            <NavItem.Desktop key={link.label} {...link} />
          ))}
        </HStack>
      </Box>
    </Box>
  );
};

const MobileNavCategoryMenu = () => {
  return (
    <Box
      width="32%"
      minW="100px"
      bg={mode("gray.50", "gray.700")}
      color={mode("gray.600", "gray.100")}
      borderEndWidth="1px"
      py="6"
    >
      <Stack spacing="1">
        {menus.map((link) => (
          <NavItem.Mobile
            key={link.label}
            {...link}
            isActive={link.label === "Men"}
          />
        ))}
      </Stack>
    </Box>
  );
};

export const NavCategoryMenu = {
  Mobile: MobileNavCategoryMenu,
  Desktop: DesktopNavCategoryMenu,
};

type NavActionProps = {
  href?: string;
  label: string;
  icon?: React.ElementType;
  isActive?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
};

const MobileNavAction = (props: NavActionProps) => {
  const { label, icon, isActive, href, children } = props;
  return (
    <Center
      as="a"
      href={href}
      height="56px"
      rounded="4"
      aria-current={isActive ? "page" : undefined}
      _activeLink={{ color: mode("blue.500", "blue.300") }}
      _hover={{ bg: mode("gray.100", "gray.700") }}
    >
      <Flex position="relative" direction="column" align="center" as="button">
        {icon ? <Box fontSize="xl" as={icon} /> : null}
        <Text fontSize="sm" fontWeight="medium">
          {label}
        </Text>
        {children}
      </Flex>
    </Center>
  );
};

const DesktopNavAction = (props: NavActionProps) => {
  const { label, icon, href, onClick } = props;
  const anchorLinkProps = {
    as: "a",
    href,
  };
  const buttonProps = {
    as: "button",
    onClick,
  };

  const actionProps = href ? anchorLinkProps : buttonProps;
  return (
    <HStack spacing="2" {...actionProps}>
      <Text fontWeight="semibold" whiteSpace="nowrap">
        {label}
      </Text>
      {icon ? <Icon as={icon} /> : null}
    </HStack>
  );
};

export const NavAction = {
  Mobile: MobileNavAction,
  Desktop: DesktopNavAction,
};
export const MobileBottomNav = () => (
  <Box
    bg={mode("white", "gray.800")}
    pos="fixed"
    width="full"
    bottom="env(safe-area-inset-bottom)"
    borderTopWidth="1px"
    display={{ lg: "none" }}
  >
    <SimpleGrid columns={4} padding="2">
      <NavAction.Mobile {...items.cart} isActive>
        <CartCount right="-2">3</CartCount>
      </NavAction.Mobile>
      <NavAction.Mobile {...items.search} />
      <NavAction.Mobile {...items.user} />
      <NavAction.Mobile {...items.wishlist} />
    </SimpleGrid>
  </Box>
);

export const data = {
  category: {
    label: "Categories",
    links: [
      { label: "Men’s fashion", url: "#" },
      { label: "New arrivals", url: "#" },
      { label: "Clothing", url: "#" },
      { label: "Footwear", url: "#" },
      { label: "Watches", url: "#" },
      { label: "Jewellry", url: "#" },
      { label: "Backpacks", url: "#" },
      { label: "Luggage", url: "#" },
    ],
  },
  featured: {
    label: "Top Brands",
    links: [
      { label: "Nike", url: "#" },
      { label: "Tommy Hilfiger", url: "#" },
      { label: "Skechers", url: "#" },
      { label: "Converse", url: "#" },
      { label: "Puma", url: "#" },
      { label: "Adidas", url: "#" },
      { label: "Under Armour", url: "#" },
      { label: "Jack & Jones", url: "#" },
    ],
  },
};

export const CurrencySelect = () => (
  <Select
    border="0"
    color={useColorModeValue("gray.600", "gray.300")}
    focusBorderColor={useColorModeValue("blue.500", "blue.200")}
    fontWeight="medium"
    fontSize="sm"
    aria-label="Select Currency"
  >
    <option value="USD">USD</option>
    <option value="EUR">EUR</option>
    <option value="AED">AED</option>
  </Select>
);

export const CartCount = (props: SquareProps) => (
  <Circle
    fontSize="xs"
    fontWeight="semibold"
    centerContent
    position="absolute"
    top="-2"
    right="-18px"
    bg={mode("red.500", "red.300")}
    color={mode("white", "gray.800")}
    width="5"
    height="5"
    {...props}
  />
);
export type NavBarProps = {
  parentOptions: DropdownItemType[];
  serviceOptions: MenuItemType[];
  contactCountriesOptions: ContactModalType["countries"];
  onSearch: (s: string) => Promise<SearchResultType[]>;
  searchHistories: SearchHistoryType[];
};
export const NavBar: React.FC<NavBarProps & BoxProps> = (props) => {
  const {
    parentOptions,
    serviceOptions,
    contactCountriesOptions,
    onSearch,
    searchHistories,
    ...rest
  } = props;
  const { onToggle, isOpen, onClose, onOpen } = useDisclosure();
  const menuItems = [
    {
      label: "Dashboard",
      url: "/dashboard",
    },
    {
      label: "My Profile",
      url: "/user/profile",
    },
    {
      label: "My Subjects",
      url: "/user/subjects",
    },
    {
      label: "Tutoring policies",
      url: "/tutoring-policy",
    },
  ];
  return (
    <Box bg="white" shadow="base" zIndex="banner" {...rest}>
      <Flex
        direction="column"
        pb="4.5rem"
        overflow="hidden"
        display={{ base: "flex", lg: "none" }}
      >
        <Box px="4" py="4" borderBottomWidth="1px" overflow="auto">
          <Flex
            align="center"
            justify="space-between"
            mb="3"
            display={{ base: "flex", lg: "none" }}
          >
            <HStack spacing="3">
              <Center w="8" h="8" as="button" type="button">
                <VisuallyHidden>Toggle Menu</VisuallyHidden>
                <Box as={MdMenu} fontSize="3xl" />
              </Center>
              <Logo h="6" />
            </HStack>
            <Box>
              <CurrencySelect />
            </Box>
          </Flex>
          <SearchInput />
        </Box>

        {/* <Flex flex="1" fontSize="sm" overflow="auto">
          <NavCategoryMenu.Mobile />
          <NavCategorySubmenu.Mobile />
        </Flex> */}
        {/* <MobileBottomNav /> */}
      </Flex>

      <Box display={{ base: "none", lg: "block" }}>
        <Box borderBottomWidth="1px" bg="white" borderColor="gray.200">
          <Box maxW="1560px" mx="auto" px={{ base: "8", lg: "16" }} bg="white">
            <Flex
              height="4.6rem"
              align="center"
              justify="space-between"
              width="full"
            >
              <HStack spacing={12} align="center">
                <Logo h={6} />
                <ButtonGroup spacing={10} flexShrink={0}>
                  <HoverNavDropdown
                    items={parentOptions}
                    render={(_isOpen, _onClose) => (
                      <Button
                        variant="link"
                        fontWeight="semibold"
                        onMouseEnter={onClose}
                        _hover={{ textDecoration: "none", color: "blue.500" }}
                        rightIcon={
                          <PopoverIcon fontSize="xl" isOpen={_isOpen} />
                        }
                        onClick={_onClose}
                        colorScheme="blue"
                        color={_isOpen ? "blue.500" : "gray.800"}
                      >
                        For parents
                      </Button>
                    )}
                  />
                  <Button
                    variant="link"
                    fontWeight="semibold"
                    _hover={{ textDecoration: "none", color: "blue.500" }}
                    rightIcon={<PopoverIcon fontSize="xl" isOpen={isOpen} />}
                    onClick={onToggle}
                    onMouseEnter={onOpen}
                    colorScheme="blue"
                    color={isOpen ? "blue.500" : "gray.800"}
                  >
                    All services
                  </Button>
                </ButtonGroup>
              </HStack>
              <Box width="full" maxW="sm" mx="8" onMouseEnter={onClose}>
                <SearchLikeButton
                  onSearch={onSearch}
                  histories={searchHistories}
                >
                  What do you want to learn?
                </SearchLikeButton>
              </Box>
              <HStack onMouseEnter={onClose} spacing="10" flexShrink={0}>
                <ContactUs
                  countries={contactCountriesOptions}
                  onChat={() => {}}
                  defaultCountry="ng"
                  render={(_onOpen) => (
                    <NavAction.Desktop
                      label="Contact us"
                      icon={RiCustomerServiceLine}
                      onClick={_onOpen}
                    />
                  )}
                />
                <Box position="relative">
                  <NavAction.Desktop label="Jobs board" href="/tutoring/jobs" />
                  <CartCount>1</CartCount>
                </Box>
                <Menu isLazy>
                  <MenuButton
                    px={3}
                    py={2}
                    transition="all 0.2s"
                    justifyContent="center"
                    display="flex"
                    borderRadius="40px"
                    alignItems="center"
                    borderColor="gray.200"
                    shadow="fbShadow"
                    borderWidth="1px"
                    _hover={{ shadow: "md" }}
                  >
                    <HStack>
                      <Icon fontSize="md" as={RiMenuLine} />
                      <Avatar size="xs" />
                    </HStack>
                  </MenuButton>
                  <MenuList shadow="fbShadow">
                    {menuItems.map((item) => {
                      return (
                        <MenuItem
                          as={Link}
                          href={item.url}
                          _hover={{ textDecoration: "none" }}
                        >
                          {item.label}
                        </MenuItem>
                      );
                    })}
                    <MenuDivider />
                    <MenuItem>Lessons</MenuItem>
                    <MenuItem>Requests</MenuItem>
                  </MenuList>
                </Menu>
              </HStack>
            </Flex>
          </Box>
        </Box>
        {/* <NavCategorySubmenu.Desktop items={serviceOptions} isOpen={isOpen} /> */}
      </Box>
    </Box>
  );
};
